import _ from 'lodash';
import orderManagement from './orderManagement';
import stadiumManagement from './stadiumManagement';
import userManagement from './userManagement';

export default _.union(
  orderManagement,
  stadiumManagement,
  userManagement,
  [{
    name: 'stadiumSystem',
    path: '/stadiumSystem',
    meta: { title: '场馆系统' },
    component: require('views/common/blank.vue').default
  }, {
    name: 'swimmingStadium',
    path: '/stadiumSystem/:stadiumType/swimmingStadium/:stadiumId',
    meta: { title: '游泳馆' },
    component: require('views/common/blank.vue').default
  }]
);
